import axios from '@utils/axios';
import i18n from '@utils/localization';
import router from '@router/router';

const createEditUser = {
  state: {
    userId: 0,
    email: '',
    password: '',
    availableRoles: [],
    role: {},
    color: 1,
    mainDoctor: false
  },
  mutations: {
    setUserId(state, id) {
      state.userId = id;
    },
    setEmail(state, email) {
      state.email = email;
    },
    setPassword(state, password) {
      state.password = password;
    },
    setAvailableRoles(state, roles) {
      state.availableRoles = roles;
    },
    setRole(state, role) {
      state.role = role;
    },
    setColor(state, color) {
      state.color = color;
    },
    setMainDoctor(state, doctor) {
      state.mainDoctor = doctor;
    }
  },
  actions: {
    createUser(context) {
      return axios.put('admin/users/create', {
        Email: context.state.email,
        RoleId: context.state.role.id,
        Color: context.state.color,
        IsMainDoctor: (context.state.role.name === 'Lékař' || context.state.role.name === 'Doctor') && context.state.mainDoctor
      });
    },
    editUser(context) {
      return axios.patch('admin/users/edit', {
        UserId: Number(context.state.userId),
        RoleId: context.state.role.id,
        Color: context.state.color,
        IsMainDoctor: (context.state.role.name === 'Lékař' || context.state.role.name === 'Doctor') && context.state.mainDoctor
      });
    },
    resetContext(context) {
      context.commit('setUserId', 0);
      context.commit('setEmail', '');
      context.commit('setPassword', '');
      context.commit('setAvailableRoles', []);
      context.commit('setColor', 1);
      context.commit('setMainDoctor', false);
    },
    fetchRoles(context) {
      axios.get('/admin/roles', {
        params: {
          locale: i18n.locale
        }
      }).then((res) => {
        if (res.status === 200 && res.data.result.length > 0) {
          context.commit('setAvailableRoles', res.data.result);
        }
      }).catch((err) => Promise.reject(err));
    },
    fetchUser(context) {
      return axios.get('admin/users/getuser', {
        params: {
          Id: Number(context.state.userId),
          Locale: i18n.locale
        }
      })
        .then((res) => {
          context.commit('setEmail', res.data.result.email);
          context.commit('setRole', res.data.result.role);
          context.commit('setColor', res.data.result.color);
          context.commit('setMainDoctor', res.data.result.isMainDoctor);
          Promise.resolve(true);
        }).catch(() => {
          router.push({ name: 'admin.users.view' });
        });
    },
    markPasswordReset(context) {
      return axios.post('admin/users/markreset', {
        UserId: Number(context.state.userId)
      });
    }
  },
  namespaced: true
};

export default createEditUser;
